import { STATUS_INIT } from 'constants/statuses.constants';

export const getInitialState = () => ({
  user: null,
  token: null,
  isAuthenticated: null,
  status: STATUS_INIT,
  error: null,
});
